import { makeStyles } from '@mui/styles';

export const useItemRowStyle = makeStyles(() => ({
  cell: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));
